// GAVION recruiting (spec §4): the number of new applications next to « Recrutement » (admins only; hidden at 0,
// « 99+ » above 99). Refreshed every 5 minutes and after every « Recrutement » action (RECRUITING_QUERY_KEY).
import { useQuery } from "@tanstack/react-query";
import { usePermissions, useTranslate } from "ra-core";
import { SidebarMenuBadge } from "@/components/ui/sidebar";
import { useRecruitingClient } from "./api/useRecruitingClient";
import { RECRUITING_QUERY_KEY } from "./api/types";

const POLL_MS = 5 * 60_000;

export function useNewApplicationsCount(): number {
  const { permissions } = usePermissions();
  const client = useRecruitingClient();
  const isAdmin = permissions === "admin";
  const { data } = useQuery({
    queryKey: [...RECRUITING_QUERY_KEY, "new-count"],
    queryFn: () => client.newCount(),
    enabled: isAdmin,
    retry: false,
    staleTime: POLL_MS,
    refetchInterval: POLL_MS,
  });
  return isAdmin ? (data ?? 0) : 0;
}

const shown = (n: number) => (n > 99 ? "99+" : String(n));

export const RecruitingNavBadge = () => {
  const t = useTranslate();
  const n = useNewApplicationsCount();
  if (n === 0) return null;
  return (
    <SidebarMenuBadge
      aria-label={t("gavion.recruiting.badge", { smart_count: n })}
    >
      {shown(n)}
    </SidebarMenuBadge>
  );
};

export const RecruitingCount = () => {
  const t = useTranslate();
  const n = useNewApplicationsCount();
  if (n === 0) return null;
  return (
    <span
      className="ml-auto rounded-full bg-primary px-2 text-xs text-primary-foreground"
      aria-label={t("gavion.recruiting.badge", { smart_count: n })}
    >
      {shown(n)}
    </span>
  );
};
